import type { TranslationKey } from '@/lib/i18n';

export const NEWSLETTER_TITLE = [
  'common:newsletter.title',
  'Stay in the loop',
] as const satisfies TranslationKey;

export const NEWSLETTER_PLACEHOLDER = [
  'common:newsletter.placeholder',
  'Enter your email',
] as const satisfies TranslationKey;

export const NEWSLETTER_SUBSCRIBE = [
  'common:newsletter.subscribe',
  'Subscribe',
] as const satisfies TranslationKey;

export const NEWSLETTER_SUCCESS = [
  'common:newsletter.success',
  'Thanks for subscribing!',
] as const satisfies TranslationKey;

export const NEWSLETTER_ERROR_INVALID = [
  'common:newsletter.error.invalid',
  'Please enter a valid email',
] as const satisfies TranslationKey;

export const NEWSLETTER_ERROR_GENERIC = [
  'common:newsletter.error.generic',
  'Something went wrong. Try again.',
] as const satisfies TranslationKey;
